import { render, staticRenderFns } from "./EventUsers.vue?vue&type=template&id=2504bda6&"
import script from "./EventUsers.vue?vue&type=script&lang=js&"
export * from "./EventUsers.vue?vue&type=script&lang=js&"
import style0 from "./EventUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventUsers.vue"
export default component.exports